/**
 * Dashboard API client for internal users.
 *
 * Uses the internal auth token (rtf_token) instead of the distributor token.
 * On 401, redirects to SSO login instead of manage.realtimefeedback.com.
 */
import createClient, { type Middleware } from "openapi-fetch";
import type { paths } from "./schema";
import { getAuthToken, redirectToLogin } from "../auth/useAuth";
import { apiUrl } from "./config";

const dashboardAuthMiddleware: Middleware = {
  async onRequest({ request }) {
    const token = getAuthToken();
    if (token) {
      request.headers.set("Authorization", `Bearer ${token}`);
    }
    return request;
  },
  async onResponse({ response }) {
    if (response.status === 401) {
      if (import.meta.env.DEV) {
        const { clearAuth } = await import("../auth/useAuth");
        clearAuth();
      } else {
        redirectToLogin();
      }
    }
    return response;
  },
};

const _dashboardClient = createClient<paths>({
  baseUrl: apiUrl,
});
_dashboardClient.use(dashboardAuthMiddleware);

export function getDashboardApiClient() {
  return _dashboardClient;
}
